require('./collectiveLandingView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('commonsComponents/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');

// @actions
const collectiveLandingActions = require('actions/collectiveLanding');

// @components
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const OKRadioSwitch = require('components/commons/OKRadioSwitch/OKRadioSwitch');
const OKRadioGroup = require('components/commons/OKRadioGroup/OKRadioGroup');
const CollectiveLandingProductBox = require('components/collectiveLandingProductBox/collectiveLandingProductBox');
const CollectiveLandingFAQ = require('components/collectiveLandingFAQ/collectiveLandingFAQ');

// @ constants
const {
    faqList
} = require('constants/collectiveLanding');

class CollectivesLandingView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedValue: '',
        }
        this.buildRadioSwitch = this.buildRadioSwitch.bind(this);
        this.buildRadioSwitchItems = this.buildRadioSwitchItems.bind(this);
        this.handleRadioGroupChange = this.handleRadioGroupChange.bind(this);
        this.buildProductContent = this.buildProductContent.bind(this);
    }

    componentDidMount() {
        this.props.getCollectiveLandingProductList();
    }

    buildRadioSwitchItems(productList) {
        const productContents = this.props.immCollectiveLandingInfo.get('byId');
        return productList.map((productId) => {
            const productName = productContents.getIn([productId, 'productName']);
            return (
                <OKRadioSwitch
                    className="collectives-landing-view__radio-switch-item"
                    value={productId}
                    key={productId}
                >
                    <span>{productName}</span>
                </OKRadioSwitch>
            );
        });
    }

    handleRadioGroupChange(value) {
        this.setState({
            selectedValue: value
        });
    }

    buildRadioSwitch(productList) {
        const selectedValue = this.state.selectedValue || productList.get(0);
        return (
            <div className="collectives-landing-view__radio-switch" >
                <OKRadioGroup
                    className="collectives-landing-view__radio-group"
                    name="collectiveProductList"
                    onChange={value => this.handleRadioGroupChange(value)}
                    selectedValue={selectedValue}
                >
                    {this.buildRadioSwitchItems(productList)}
                </OKRadioGroup>
            </div>
        );
    }

    buildProductContent(productList) {
        const selectedValue = this.state.selectedValue || productList.get(0);
        const { immCollectiveLandingInfo, immCards } = this.props;
        const productContents = immCollectiveLandingInfo.get('byId');
        const productDetails = productContents.get(selectedValue);
        return (
            <CollectiveLandingProductBox immProductDetails={productDetails} immCards={immCards}/>
        )
    }

    render() {
        const { immProfile, immCollectiveLandingInfo, getCollectiveLandingProductList} = this.props;

        const productList = immCollectiveLandingInfo.get('byOrder');
        const collectiveName = immProfile.get('collectiveName');
        const title = <FormattedText value="colectivesLanding-colectivesLanding_title" injectedStrings={[collectiveName]}/>;
        const subTitle = formatText('colectivesLanding-colectivesLanding_subTitle');
        const headerText = formatText('colectivesLanding-colectivesLanding_businessBenefitsHeader');
        let productContents;
        let radioOptions;

        const colectiveLandingHeaderElement = (
            <div className="collectives-landing-view__title-section">
                <span className="collectives-landing-view__title">
                    {headerText}
                </span>
            </div>
        );

        if (immCollectiveLandingInfo.get('isFetching')) {
            productContents = <LoadingSection />;
        } else if (immCollectiveLandingInfo.get('error')) {
            const retryButton = (
                <OKButton onClick={getCollectiveLandingProductList}>
                    <FormattedText value="common-retry" />
                </OKButton>
            );
            productContents = (
                <div className="collectives-landing-view__empty-state">
                    <EmptyState
                        primaryText={formatText('colectivesLanding-colectivesLanding_connectionError')}
                        button={retryButton}
                        iconType="nointernet-banking"
                    />
                </div>
            );
        } else if (productList.size) {
            radioOptions = this.buildRadioSwitch(productList);
            productContents = this.buildProductContent(productList);
        } else {
            productContents = (
                <div className="collectives-landing-view__empty-state">
                    <EmptyState
                        primaryText={formatText('colectivesLanding-colectivesLanding_noProduct')}
                        iconType="search-banking"
                    />
                </div>
            );
        }

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="small" section="pg" customClass="col-xs-12"
                        >
                            <OKHeaderLanding title={colectiveLandingHeaderElement}/>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <section className="collectives-landing-view">
                            <div>
                                <p className="collectives-landing-view__header-title">
                                    {title}
                                </p>
                                <p className="collectives-landing-view__header-subtitle">
                                    {subTitle}
                                </p>
                            </div>
                            {radioOptions}
                            {productContents}
                        </section>
                    </div>
                </div>
                <CollectiveLandingFAQ FAQData={faqList} />
            </div>
        );
    }
}

CollectivesLandingView.propTypes = {
    getCollectiveLandingProductList: PropTypes.func.isRequired,
    immCollectiveLandingInfo: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
};

module.exports.constructor = CollectivesLandingView;
module.exports.CollectivesLandingView = connect(
    state => ({
        immCards: state.cards,
        immProfile: state.profile,
        immCollectiveLandingInfo: state.collectiveLanding
    }),
    {
        getCollectiveLandingProductList: collectiveLandingActions.getCollectiveLandingProductList
    }
)(CollectivesLandingView);